import { useState } from 'react';
import { supabase } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';
import Seo from "../Seo";

export default function LoginPage() {
    const [loginEmail, setLoginEmail] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [signUpPasswordConfirm, setSignUpPasswordConfirm] = useState('');
    const [username, setUsername] = useState('');
    const [isSignUp, setIsSignUp] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async () => {
        const { error } = await supabase.auth.signInWithPassword({
            email: loginEmail,
            password: loginPassword,
        });
        if (error) alert(error.message);
        else navigate('/headspace');
    };

    const handleSignUp = async () => {
        if (loginPassword !== signUpPasswordConfirm) {
            alert("Passwords don't match!");
            return;
        }

        const {error } = await supabase.auth.signUp({
            email: loginEmail,
            password: loginPassword,
        });

        if (error) {
            alert(error.message);
            return;
        }

        // Update user metadata with display_name as username
        const { error: updateError } = await supabase.auth.updateUser({
            data: {
                display_name: username,
            },
        });

        if (updateError) {
            alert('Failed to set display name: ' + updateError.message);
            return;
        }

        alert('Sign-up successful!');
        navigate('/headspace');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSignUp) {
            await handleSignUp();
        } else {
            await handleLogin();
        }
    };

    return (
        <div className="min-h-screen relative flex items-center justify-center bg-[#fdfaf6]">
            <Seo title="Headspace" path="/headspace" noindex />

            <button
                className="fixed top-6 left-6 bg-white text-accent px-3 py-1 rounded shadow hover:text-[#b483d1] z-50"
                onClick={() => navigate('/blog')}
            >
                ← Back
            </button>
            <div className="bg-white p-8 rounded shadow w-80">
                <h2 className="text-2xl font-bold mb-4">{isSignUp ? 'Sign Up' : 'Log In'}</h2>

                <form onSubmit={handleSubmit}>
                    {isSignUp && (
                        <input
                            className="w-full p-2 border rounded mb-4"
                            type="text"
                            placeholder="Display Name"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    )}

                    <input
                        className="w-full p-2 border rounded mb-4"
                        type="email"
                        placeholder="Email"
                        value={loginEmail}
                        onChange={(e) => setLoginEmail(e.target.value)}
                    />

                    <input
                        className="w-full p-2 border rounded mb-2"
                        type="password"
                        placeholder="Password"
                        value={loginPassword}
                        onChange={(e) => setLoginPassword(e.target.value)}
                    />

                    {isSignUp && (
                        <input
                            className="w-full p-2 border rounded mb-4"
                            type="password"
                            placeholder="Confirm Password"
                            value={signUpPasswordConfirm}
                            onChange={(e) => setSignUpPasswordConfirm(e.target.value)}
                        />
                    )}

                    <button
                        type="submit"
                        className="bg-accent text-white px-4 py-2 rounded w-full mb-2"
                    >
                        {isSignUp ? 'Sign Up' : 'Log In'}
                    </button>

                    <button
                        type="button"
                        className="bg-gray-300 text-black px-4 py-2 rounded w-full mb-2"
                        onClick={(e) => {
                            e.preventDefault();
                            sessionStorage.setItem("guest", "true");
                            navigate('/headspace');
                        }}
                    >
                        Continue as Guest
                    </button>
                </form>

                <button
                    className="text-sm text-center underline w-full"
                    onClick={() => setIsSignUp(!isSignUp)}
                >
                    {isSignUp ? 'Already have an account? Log In' : "Don't have an account? Sign Up"}
                </button>
            </div>
        </div>
    );
}
